
<div class="auth-wrapper">
  <div class="auth-content">
    <div class="card shadow p-3 mb-5 bg-white rounded">
      <div class="row align-items-center text-center">
        <div class="col-md-12">
          <div class="card-body px-3">
            <img src="assets/images/IFSLogo.png" alt="" class="auth-logo mb-4">
            <h4 class="mb-3 fw-normal">Change Password</h4>
            <div *ngIf="errorMessageList.length > 0" class="alert alert-danger pb-4 f-w-400 text-left">
              <strong> Please correct the following:</strong>
              <ul>
                <li *ngFor="let errorMessage of errorMessageList">{{errorMessage}}</li>
              </ul>
            </div>
            <div class="row align-items-center">
              <div class="col-lg-12">

                <!--fields-->
                <div class="row pt-4">
                  <div class="col">

                    <!--Old Password-->
                    <div class="row">
                      <div class="col-5 px-0">
                        <label for="oldPassword" class="col-form-label-sm">Current Password</label>
                      </div>
                      <div class="col">
                        <input type="password"
                               class="form-control form-control-sm"
                               id="oldPassword"
                               [(ngModel)]="oldPassword">
                      </div>
                    </div>

                    <!--New Password-->
                    <div class="row">
                      <div class="col-5 px-0">
                        <label for="newPassword" class="col-form-label-sm">New Password</label>
                      </div>
                      <div class="col">
                        <input type="password"
                               class="form-control form-control-sm"
                               id="newPassword"
                               [(ngModel)]="newPassword">
                      </div>
                    </div>

                    <!--Confirm New Password-->
                    <div class="row">
                      <div class="col-5 px-0">
                        <label for="confirmNewPassword" class="col-form-label-sm">Confirm New Password</label>
                      </div>
                      <div class="col">
                        <input type="password"
                               class="form-control form-control-sm"
                               id="confirmNewPassword"
                               [(ngModel)]="confirmNewPassword">
                      </div>
                    </div>

                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <button class="btn btn-block btn-primary mb-4 mt-5" (click)="changePassword()">Change Password</button>
                  </div>
                </div>
                <div class="row">
                  <a href="javascript:" (click)="goToLogin()"><span>Back to login?</span></a>
                </div>
             
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

